const NAMESPACE = "externalColumnMappingEditor";

const KEYS = {
    invalidCharactersInColumnNameErrorMessageTemplate: "invalidCharactersInColumnNameErrorMessage"
};

const MESSAGES = {
    [KEYS.invalidCharactersInColumnNameErrorMessageTemplate]: {
        value: "These characters are not allowed: {invalid}",
        comment:
            "Error shown when column name contains invalid characters. Shown in compact element, so brevity is important."
    }
};

export { KEYS, NAMESPACE, MESSAGES };
